import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { inject } from "@angular/core";
import { UserInfoService } from "../../services/user-info.service";
import { PlatformMismatchNoticeService } from "../../services/platform-mismatch-notice.service";
import { canAccessEpakRoutes } from "./platform-role-policy";

/**
 * Guard for ePAK platform routes. Only ACTIVE and EXTERNAL roles may access.
 * PAID_CUSTOMER users are redirected to the Wellvia hub (/paid).
 * Platform switching must go through platform tabs (backend role switch).
 */
export const epakRoleGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean => {
  const router = inject(Router);
  const userInfoService = inject(UserInfoService);
  const platformMismatchNotice = inject(PlatformMismatchNoticeService);
  const role = userInfoService.getSessionContext()?.patientRole;

  if (role == null) {
    return true; // AuthGuard handles unauthenticated; let it run first
  }

  if (canAccessEpakRoutes(role)) {
    return true;
  }

  platformMismatchNotice.notifyEpakRouteBlocked();
  router.navigate(["/paid"]);
  return false;
};
